import MyFavorites from './MyFavorites.vue'

export default MyFavorites
